import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import viCommon from "./locales/vi/common";
import enCommon from "./locales/en/common";
import viGuide from "./locales/vi/guide";
import enGuide from "./locales/en/guide";
import { ENV } from "../config/env";

const DEFAULT_LANGUAGE = ENV.DEFAULT_LANGUAGE;
const STORAGE_KEY = "preferred_language";

const resources = {
  vi: {
    common: viCommon,
    guide: viGuide,
  },
  en: {
    common: enCommon,
    guide: enGuide,
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: "customStorageDetector",
  lookup() {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && (stored === "vi" || stored === "en")) {
      return stored;
    }
    return DEFAULT_LANGUAGE;
  },
  cacheUserLanguage(lng: string) {
    localStorage.setItem(STORAGE_KEY, lng);
  },
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ["vi", "en"],
    fallbackLng: DEFAULT_LANGUAGE,
    defaultNS: "common",
    ns: ["common", "guide"],
    detection: {
      order: ["customStorageDetector"],
      caches: [],
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
